import * as yup from "yup";

const EmailSettingsFormValidation= yup.object().shape({
  sendHost: yup.string().required("Servidor de envio é obrigatório"),
  sendPort: yup
    .number()
    .typeError("A porta deve ser um número")
    .required("Porta de envio é obrigatória")
    .positive()
    .integer(),
  sendFrom: yup.string().email("Email inválido").required("Email remetente é obrigatório"),
  sendUsername: yup.string().required("Usuário de envio é obrigatório"),
  sendPassword: yup.string().min(6, "Senha deve ter no mínimo 6 caracteres").required("Senha é obrigatória"),

  receiveHost: yup.string().required("Servidor de recebimento é obrigatório"),
  receivePort: yup
    .number()
    .typeError("A porta deve ser um número")
    .required("Porta de recebimento é obrigatória")
    .positive()
    .integer(),
  receiveFrom: yup.string().email("Email inválido").required("Email de recebimento é obrigatório"),
  receiveUsername: yup.string().required("Usuário de recebimento é obrigatório"),
  receivePassword: yup.string().min(6, "Senha deve ter no mínimo 6 caracteres").required("Senha é obrigatória"),
});
export default EmailSettingsFormValidation;